import React from 'react';

import { bemCssModules } from '@utils';

import Apple from './icons/apple.svg';
import ArrowDown from './icons/arrow_down.svg';
import ArrowRight from './icons/arrow_right.svg';
import Copied from './icons/copied_icon.svg';
import Copy from './icons/copy_icon.svg';
import Eye from './icons/eye_icon.svg';
import EyeOpened from './icons/eye_opened_icon.svg';
import GoogleMarket from './icons/google_market.svg';
import Back from './icons/icon_back.svg';
import Close from './icons/icon_close.svg';
import CloseDesktop from './icons/icon_close_desktop.svg';

import style from './Icon.scss';

const cn = bemCssModules(style, 'Icon');

const iconsMap = {
  arrow_right: ArrowRight,
  arrow_down: ArrowDown,
  eye_closed: Eye,
  eye_opened: EyeOpened,
  back_arrow: Back,
  close_cross: Close,
  close_cross_desktop: CloseDesktop,
  copy_button: Copy,
  check_mark: Copied,
  apple: Apple,
  google_market: GoogleMarket,
};

export type TIcon = {
  className?: string;
  name: keyof typeof iconsMap;
  size?: number;
};

export const Icon: React.FC<TIcon> = props => {
  const { name, size = 24, className } = props;
  const CurrentIcon = iconsMap[name];
  const wrapperStyle = {
    '--icon-container-width': `${size}px`,
  } as React.CSSProperties;

  return (
    <div style={wrapperStyle} className={cn(null, [className])}>
      <CurrentIcon />
    </div>
  );
};

export default Icon;
